import { useParams } from "react-router-dom";
import FinalApproveCertificateForm from "../../../../../components/common-content/FinalApproveCertificateForm";
import Loader from "../../../../../components/custom/Loader";
import CopyrightPreviewFormOne from "../../../../../components/preview_applications/copyright/CopyrightPreviewFormOne";
import CopyrightPreviewFormTwo from "../../../../../components/preview_applications/copyright/CopyrightPreviewFormTwo";
import PaymentPreview from "../../../../../components/preview_applications/payment/PaymentPreview";
import { useGetSubmittedCopyrightDetailsQuery } from "../../../../../redux/api/submittedCopyrightAgreementApiSlice";
import { useAuth } from "../../../../../utils/authorization";
import { CopyrightGenerateAttachArray } from "../../../../../utils/CopyrightGenerateAttachArray";
import { transformCopyrightData } from "../../../../../utils/transformCopyrightData";
import CommonDetails from "../../details/CommonDetails";

const FinalApprovedCopyrightDetails = () => {
  const { authUser } = useAuth();
  const { id } = useParams();
  const { data, isLoading } = useGetSubmittedCopyrightDetailsQuery(id, {
    refetchOnMountOrArgChange: true,
  });

  const details = data?.data?.profileDetail;

  const forInfo = transformCopyrightData(data);

  if (isLoading) {
    return <Loader />;
  }
  const infoTable = CopyrightGenerateAttachArray(forInfo);

  const info = {
    fileStatus: Number(data?.data?.fileStatus),
    noteNumber: data?.data?.trackReg,
    regNumber: "",
    applicantName: details?.profileDetailType?.[0]?.name,
    workTitle: details?.workTitle,
    category: details?.category?.name,
    amount: data?.data?.amount,
    challan: Number(data?.data?.st) === 3 ? "চালান" : "ট্রেজারি",
    challanNumber:
      Number(data?.data?.st) === 3
        ? data?.data?.echallanId
        : data?.data?.treasuryNo,
    treasuryDate: data?.data?.treasuryDate || new Date(),
    admin: data?.data?.admin,
    // TODO: certificate data
  };

  const formOne = (
    <div className="pt-5">
      <CopyrightPreviewFormOne data={data?.data} />
    </div>
  );
  const formTwo = (
    <div className="pt-5">
      <CopyrightPreviewFormTwo data={details} />
    </div>
  );

  const comments =
    authUser?.id === 8
      ? data?.data?.comments.find((c) => Number(c.submit) === 2)
      : data?.data?.comments.length > 0 && data?.data?.comments[0];

  const noteSheetList =
    data?.data?.comments.filter((c) => Number(c.submit) === 1) ?? [];
  const pageTitle = "চূড়ান্ত ভাবে অনুমোদিত আবেদন পত্র";

  const content = <FinalApproveCertificateForm data={data?.data} />;

  const commentsNoteSheet = {
    noteSheetList,
    noteSheetValues: comments?.status,
  };

  return (
    <div>
      <CommonDetails
        content={content}
        commentsNoteSheet={commentsNoteSheet}
        formOne={formOne}
        formTwo={formTwo}
        payment={
          <div className="p-4 mt-5">
            <PaymentPreview data={data?.data} />
          </div>
        }
        info={info}
        infoTable={infoTable}
        breadcrumbsTitle={pageTitle}
      />
    </div>
  );
};

export default FinalApprovedCopyrightDetails;
